'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var certificates = exports.certificates = {
  title: 'Certify your training',
  description: 'Improve your CV with personal non-transferable Certificates',
  find_courses: 'Find courses',
  how_it_works_title: 'How does it work?',
  learn_title: 'Sign in to any course',
  learn_description: 'Certificates are available for all courses. You need to complete at least 90% of the course to access the Certificate.',
  download_title: 'Download the Certificate',
  download_description: 'It will be visible from any device and you can download it as a pdf as many times as you would like.',
  verify_title: 'Show your skills',
  verify_description: 'Each Certificate has a unique code to show its validity, personal and non-transferable.',
  validation_title: 'Unique validation with secure technology',
  validation_description: 'A set of algorithms is used when issuing the Certificate so that it is unique and irreplicable.',
  validation_features: JSON.stringify(['url', 'qr', 'everywhere']),
  url_validation_title: 'URL validation',
  url_validation_description: 'On LinkedIn, you can show the URL with the validation of the Certificate. It is a public URL.',
  qr_validation_title: 'QR validation',
  qr_validation_description: 'Use the code wherever you would like. It is non-transferable and cannot be copied.',
  everywhere_validation_title: 'In any medium',
  everywhere_validation_description: 'The URL and the QR codes can be added to documents, mail or any other form.',
  how_it_looks_title: 'Your Certificate will look like this',
  register: 'Register now'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/certificates.js
// module id = 712
// module chunks = 0